import { createStore, stateSetterHandler } from '@muvi/react-common';
import { isDevtoolsEnabled } from '@/logic/state/store-devtools';

export type otpState = {
  otpTimer: {
    isRunning: boolean;
    timerVal: number;
  };
};

const initState: otpState = {
  otpTimer: {
    isRunning: true,
    timerVal: 0,
  },
};

export const useOtpTimer = createStore({
  name: 'otp-timer',
  devtools: isDevtoolsEnabled,
  persist: false,
})(initState, set => {
  const handler = stateSetterHandler(set);
  return {
    setOtpTimer: handler('otpTimer'),
  };
});
